// extracted by mini-css-extract-plugin
export default {"card-thumbnail":"card-thumbnail__sTyQS","large":"large__LBPr3","small":"small__cT-eZ","card-bg":"card-bg__pDrPb","card-client":"card-client__yuL5H"};